$ = require 'jquery'
PluginView = require 'views/plugin/plugin-view'
PopOver = require 'views/lib/pop-over'
sandboxParams = require 'data/plugin-iframe-sandbox'
t = require('views/internal/teacup-with-helpers')()

template = t.renderable (content = {}) ->
  { url, height } = content
  t.iframe '.plugin-iframe',
    allow: 'microphone; camera'
    sandbox: sandboxParams
    src: url
    style: if height then "height:#{ height }px;" else undefined

  return

module.exports = class PluginPopOverIFrameView extends PluginView
  initialize: ({ @title, @content, @callback }) ->
    @retain(@callback)

  getViewTitle: -> @title

  keepInDOM: true

  vigor: @VIGOR.NONE

  renderOnce: ->
    @$el.html(template(@content))

    @initIFrames(@model)

    @

  handleIFrameMessage: (iframe, message) ->
    switch message
      when 'done'
        if @callback?
          return @callback({ el: iframe })
        else
          PopOver.hide()
          return



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-pop-over-iframe-view.coffee